// Mapping from internal CoE lab `code` (as seeded in backend/lms_seed.py) to
// the external partner LMS URL where the actual course content lives.
// When a student clicks a lab card on the public /lms page they are taken
// straight to the partner site (new tab, session preserved on our end).

const COE_EXTERNAL_URLS = {
  "SMPL":    "https://techcatalyst.world/lms/labs/semiconductor-microelectronics-packaging",
  "READ":    "https://techcatalyst.world/lms/labs/read-reverse-engineering-adas-digital-twin",
  "MEDL":    "https://techcatalyst.world/lms/labs/medtech-engineering-design",
  "SMIA":    "https://techcatalyst.world/lms/labs/smart-manufacturing-industrial-automation",
  "AIOF":    "https://techcatalyst.world/lms/labs/ai-infra-hardware",
  "CIDSA":   "https://cidsaglobal.com/lms",
  "ESDM":    "https://techcatalyst.world/lms/labs/esdm-electronics-system-design",
  "3CI":     "https://techcatalyst.world/lms/labs/cybersecurity-cloud-cip",
  "EVFM":    "https://techcatalyst.world/lms/labs/ev-future-mobility",
  "IoT-CPS": "https://techcatalyst.world/lms/labs/iot-cyber-physical-systems",
};

export function getCoeExternalUrl(labCode) {
  if (!labCode) return null;
  return COE_EXTERNAL_URLS[labCode] || null;
}
